export function getMessagesQueue(state) {
  return state.messagesQueue;
}

export function getContactMessagesQueue(state, customerID) {
  return state.messagesQueue.queues[customerID] || [];
}

export function isQueueRunning(state, customerID) {
  return state.messagesQueue.runningQueues.includes(customerID);
}

export function getLocalFiles(state) {
  return state.messagesQueue.localFiles;
}
